import ReverbCookie from './reverb_cookie';

const token = ReverbCookie.get('reverb_user_oauth_token');

let authorization;
if (token) {
  authorization = `Bearer ${token}`;
}

export default authorization;



// WEBPACK FOOTER //
// ./javascripts/components/auth_token.js